import _ from 'lodash';
import React from 'react';
import { Stack, Typography, Rating, Button, Box, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useMutation } from 'react-fetching-library';
import { useLocation } from 'react-router-dom';

import { submitFormRatingAction } from '../../services/request';
// ICONS
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAltOutlined';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';

import toast from 'react-hot-toast';
import { useResponsive } from '../../services/hooks';
import TikTokIcon from '../@material-extend/TikTokIcon';

const StyledRating = styled(Rating)({
  '& .MuiRating-iconFilled': {
    color: '#00AB55'
  }
});

const customIcons = {
  1: {
    icon: <SentimentVeryDissatisfiedIcon style={{ fontSize: '60px' }} />,
    label: 'Bardzo zły'
  },
  2: {
    icon: <SentimentDissatisfiedIcon style={{ fontSize: '60px' }} />,
    label: 'Zły'
  },
  3: {
    icon: <SentimentSatisfiedIcon style={{ fontSize: '60px' }} />,
    label: 'Neutralny'
  },
  4: {
    icon: <SentimentSatisfiedAltIcon style={{ fontSize: '60px' }}/>,
    label: 'Dobry'
  },
  5: {
    icon: <SentimentVerySatisfiedIcon style={{ fontSize: '60px' }}/>,
    label: 'Bardzo dobry'
  }
};

function IconContainer(props) {
  const { value, ...other } = props;

  return <span {...other}>{customIcons[value].icon}</span>;
}

const FormSentInfoOLRoute = () => {
  const location = useLocation();
  const isProduction = process.env.REACT_APP_IS_PRODUCTION === 'true';

  const { formId, identifier, formikValues } = location.state || {};
  const { mutate } = useMutation(submitFormRatingAction);
  const [value, setValue] = React.useState(5);
  const [rated, setRated] = React.useState(false);
  const [description, setDescription] = React.useState('');
  const isDesktop = useResponsive('up', 'lg');

  const handleSubmit = async () => {
    const { error, payload } = await mutate({ 'form': formId, 'rating': value, description: value === 1 && description.trim().length > 0 ? description : null });
    if (!error) {
      setRated(true);
    } else {
      toast.error('Nie udało się przesłać oceny');
    }
  };

  const getFontSize = React.useMemo(() => {
    if (isDesktop) {
      return '64px';
    }

    return '22px';

  }, [isDesktop]);

  const getBoxHeight = React.useMemo(() => {
    if (isDesktop) {
      return 50;
    }

    return 20;
  }, [isDesktop]);

  if (!identifier || !formId) {
    return (
      <Typography variant="h4" align="center">
        Brak danych formularza
      </Typography>
    );
  }

  React.useEffect(() => {
    if (
      !isProduction ||
      !identifier === 'lato'
    ) {
      return;
    }
    window.dataLayer?.push({
      event: 'lead'
    });
  }, []);

  return (
    <Stack direction="column" justifyContent="center" alignItems="center" spacing={2}>
      {/* <Confetti height={2000} /> */}
      <CheckCircleOutlineIcon color="primary" sx={{ fontSize: '48px' }} />
      <Typography variant="h3" sx={{ fontSize: getFontSize }} align="center" >Formularz został pomyślnie wysłany</Typography>
      <Box height={getBoxHeight} />
      { identifier == 'zielone_szkoly'
        ? <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column">
          <Typography variant="h3" color="primary" sx={{ p: 1 }}>Dziękujemy, że wybrali Państwo Zieloną Szkołę z Sun Sport!</Typography>
          <Typography variant="h4" sx={{ fontSize: getFontSize, p: 1 }} align="center">Skontaktujemy się w ciągu trzech dni roboczych, aby omówić szczegóły i potwierdzić rezerwację.</Typography>
          <Typography variant="h4" sx={{ fontSize: getFontSize, p: 1 }} align="center">Po potwierdzeniu prześlemy link do podpisania umowy.</Typography>
          <Typography variant="h4" sx={{ fontSize: getFontSize, p: 1 }} align="center">Zachęcamy do obserwowania naszych profili na Facebooku i Instagramie – dzielimy się tam relacjami z wyjazdów, nowościami i kulisami naszych ośrodków. </Typography>
          <Typography variant="h4" sx={{ fontSize: getFontSize, p: 1 }} align="center">Warto też polecić nasze profile rodzicom – dzięki temu będą mogli na bieżąco śledzić, jak wygląda taki wyjazd, przygotowania do niego oraz relacje z pobytu dzieci!</Typography>
          <Typography variant="h4" sx={{ fontSize: getFontSize, p: 1 }} align="center">Do zobaczenia na Zielonej Szkole!</Typography>
          <Stack flexDirection="row" gap={2} mt={1}>
            <a style={{ height: '80px', color: '#4267B2' }} href="https://www.facebook.com/zieloneszkoly.sunsport" target="_blank" rel="noopener noreferrer">
              <FacebookRoundedIcon sx={{ fontSize: 60 }} />
            </a>
            <a style={{ height: '80px' }} href="https://www.instagram.com/zieloneszkoly_sunsport/" target="_blank" rel="noopener noreferrer">
              <svg width={0} height={0}>
                <radialGradient id="rg" r="150%" cx="30%" cy="107%">
                  <stop stopColor="#fdf497" offset="0" />
                  <stop stopColor="#fdf497" offset="0.05" />
                  <stop stopColor="#fd5949" offset="0.45" />
                  <stop stopColor="#d6249f" offset="0.6" />
                  <stop stopColor="#285AEB" offset="0.9" />
                </radialGradient>
              </svg>
              <InstagramIcon sx={{ fill: 'url(#rg)', fontSize: 60 }}/>
            </a>
            <a style={{ height: '80px', color: 'red' }} href="https://www.youtube.com/@sun_sport_obozy" target="_blank" rel="noopener noreferrer">
              <YouTubeIcon sx={{ fontSize: 60 }} />
            </a>
            <a style={{ height: '80px' }} href="https://www.tiktok.com/@sun_sport_obozy" target="_blank" rel="noopener noreferrer">
              <TikTokIcon sx={{ fontSize: 60 }} />
            </a>
          </Stack>
        </Box>
        : identifier == 'wyjazdy_rodzinne' ? <Stack justifyContent="center" direction="column" spacing={1}>
          <Typography color="primary" variant="h5" sx={{ fontSize: getFontSize }} align="center">Drodzy Państwo</Typography>
          <Typography color="primary" variant="h5" sx={{ fontSize: getFontSize }} align="center">wysłany formularz rezerwacyjny nie jest równoznaczny z zarezerwowaniem miejsca.</Typography>
          <Typography variant="h5" sx={{ fontSize: getFontSize }} align="center">W ciągu maksymalnie dwóch dni roboczych potwierdzimy rezerwację miejsca poprzez przesłanie kompletu dokumentów lub skontaktujemy się e-mailowo lub telefonicznie, jeżeli przesłana rezerwacja będzie wymagała omówienia.</Typography>
          <Typography variant="h5" sx={{ fontSize: getFontSize }} align="center">Kopię przesłanego przez siebie formularza otrzymali Państwo na adres e-mail wskazany w rezerwacji.</Typography>
          <Button variant="contained" onClick={() => window.open('https://sun-sport.pl/', '_blank')}>
            <Typography variant="h5" textAlign="center" sx={{ fontSize: getFontSize, textTransform: 'none' }} >
          Dowiedz się więcej o imprezach w naszych ośrodkach
            </Typography>
          </Button>
        </Stack>
          : <Stack justifyContent="center" direction="column" spacing={1}>
            <Typography color="primary" variant="h5" sx={{ fontSize: getFontSize }} align="center">Drodzy Rodzice</Typography>
            <Typography color="primary" variant="h5" sx={{ fontSize: getFontSize }} align="center">wysłany formularz rezerwacyjny nie jest równoznaczny z zarezerwowaniem miejsca.</Typography>
            <Typography variant="h5" sx={{ fontSize: getFontSize }} align="center">W ciągu maksymalnie dwóch dni roboczych potwierdzimy rezerwację miejsca poprzez przesłanie kompletu dokumentów lub skontaktujemy się e-mailowo lub telefonicznie, jeżeli przesłana rezerwacja będzie wymagała omówienia.</Typography>
            <Typography variant="h5" sx={{ fontSize: getFontSize }} align="center">Kopię przesłanego przez siebie formularza otrzymali Państwo na adres e-mail wskazany w rezerwacji.</Typography>
          </Stack>
      }
      <Box height={getBoxHeight} />
      {!_.isNil(formikValues.discount) && formikValues.discount.includes(171) ? <Typography variant="body1" sx={{ fontSize: getFontSize }} >Oto kod rabatowy dla znajomego/znajomych, wskazanych przez Państwa w przesłanym do nas formularzu rezerwacyjnym. Aby otrzymać rabat, znajomy powinien wpisać go w swoim formularzu rezerwacyjnym w pole Kod rabatowy. Wszystkie rezerwacje muszą być dokonane tego samego dnia.<br></br>Kod rabatowy: <b>PRZYJACIELE2024</b></Typography> : null}
      {!rated
        ? <>
          <Typography variant="h5" sx={{ fontSize: getFontSize }} align="center" >Ocena procesu rezerwacyjnego</Typography>
          <StyledRating
            value={value}
            onChange={(event, newValue) => {
              setValue(newValue);
            }}
            IconContainerComponent={IconContainer}
            highlightSelectedOnly
          />
          <Typography variant="h6" sx={{ fontSize: getFontSize }} >{value !== null ? customIcons[value].label : 'Brak oceny'}</Typography>
          {value === 1 ? <TextField
            label="Komentarz"
            multiline
            value={description}
            onChange={e => setDescription(e.target.value)}
            rows={6}
            variant="outlined"
            sx={{ maxWidth: '450px', width: '100%' }}
          /> : null}

          <Button
            variant="contained"
            sx={{ textTransform: 'none' }}
            disabled={value === null}
            onClick={handleSubmit}>
            <Typography variant="h5" sx={{ fontSize: getFontSize }}>
              Wyślij ocenę
            </Typography>
          </Button>
        </>
        : <Typography variant="h6" sx={{ fontSize: getFontSize }} >Dziękujemy za ocenę</Typography>}
      {/* {identifier === 'lato' && <>
        <Box height={getBoxHeight} />
        <Typography variant="h5" sx={{ fontSize: getFontSize }} align="center" >Prosimy rozważyć ubezpieczenie kosztów rezygnacji z wyjazdu (np. nagła choroba, złamanie).</Typography>
        <Button variant="contained" onClick={() => window.open('https://sun-sport.pl/lato/strefa-rodzica#ubezpieczenie', '_blank')} width="150px">
          <Typography variant="h5" textAlign="center" sx={{ fontSize: getFontSize, textTransform: 'none' }} >
                  Sprawdź szczegóły
          </Typography>
        </Button>
      </>} */}
    </Stack>
  );
};

export default FormSentInfoOLRoute;
